/* eslint-disable-next-line import/prefer-default-export */
export const JSON_SPEC_VERSION = 0;
